import { render, staticRenderFns } from "./activity520.vue?vue&type=template&id=503072a6&scoped=true&"
import script from "./activity520.vue?vue&type=script&lang=js&"
export * from "./activity520.vue?vue&type=script&lang=js&"
import style0 from "./activity520.vue?vue&type=style&index=0&id=503072a6&lang=scss&scoped=true&"
import style1 from "./activity520.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../accelerator-assessment-test-20260908/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "503072a6",
  null
  
)

export default component.exports